import { createGlobalStyle } from "styled-components"

export const GlobalStyle = createGlobalStyle`
  /* Reset */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  * {
    margin: 0;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
    -webkit-text-size-adjust: 100%;
  }

  body,
  #___gatsby,
  #gatsby-focus-wrapper {
    min-height: 100vh;
  }

  body {
    font-family:
      Inter,
      system-ui,
      -apple-system,
      BlinkMacSystemFont,
      "Segoe UI",
      sans-serif;

    background: #0b0f1a;
    color: #f9fafb;

    line-height: 1.5;
    font-synthesis: none;
    text-rendering: optimizeLegibility;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    overflow-x: hidden;
  }

  /* Medien */
  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }

  /* Formulare */
  input,
  button,
  textarea,
  select {
    font: inherit;
  }

  button {
    cursor: pointer;
  }

  textarea {
    resize: vertical;
  }

  /* Links */
  a {
    color: inherit;
    text-decoration: none;
  }

  /* Listen */
  ul,
  ol {
    list-style: none;
    padding: 0;
  }

  /* Tabellen */
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  /* Überschriften */
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.1;
    font-weight: 700;
    text-wrap: balance;
  }

  p {
    text-wrap: pretty;
  }

  /* Fokus */
  :focus-visible {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
  }

  /* Auswahl */
  ::selection {
    background: #2563eb;
    color: white;
  }

  /* Scrollbar */
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #111827;
  }

  ::-webkit-scrollbar-thumb {
    background: #374151;
    border-radius: 999px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #4b5563;
  }

  /* Theme Variablen */
  :root {
    --bg: #0b0f1a;
    --surface: #111827;
    --surface-light: #1f2937;

    --text: #f9fafb;
    --text-muted: #9ca3af;

    --primary: #3b82f6;
    --primary-hover: #2563eb;

    --success: #22c55e;
    --warning: #f59e0b;
    --danger: #ef4444;

    --radius-sm: 8px;
    --radius-md: 12px;
    --radius-lg: 16px;
    --radius-xl: 24px;

    --shadow-sm: 0 1px 3px rgba(0,0,0,.2);
    --shadow-md: 0 8px 24px rgba(0,0,0,.25);
    --shadow-lg: 0 20px 40px rgba(0,0,0,.35);

    --container: 1280px;
  }
`